import { InjectOptions, Injector, Provider } from "@angular/core";

import { WIDGET_RESOLVER } from "./widget-hub.constants";
import { WidgetResolver } from "../models/widget-resolver.interface";
import { WidgetResolverService } from "../services/widget-resolver.service";


function widgetResolverFactoryFn(injector: Injector): WidgetResolver {
    // Look for parent instance.
    const options: InjectOptions = { optional: true, skipSelf: true };
    const resolver: WidgetResolver = injector.get(WIDGET_RESOLVER, null, options);

    if (!!resolver) return resolver;

    // Otherwise create a new instance.
    const child: Injector = Injector.create({
        providers: [{ provide: WidgetResolverService }],
        parent: injector,
    });

    return child.get(WidgetResolverService);
}

export const widgetResolverProvider: Provider = {
    useFactory: widgetResolverFactoryFn,
    provide: WIDGET_RESOLVER,
    deps: [Injector]
}